import * as React from 'react';
import { Header1 } from '@cian/ui-kit';

import { IPlaceNearby } from '../../types/newbuilding/placesNearby';
import { Layout } from '../Layout';
import { VerticalSlider } from '../VerticalSlider';
import { Arrow } from './components/Arrow';
import { PlacesNearbyItem } from './components/PlacesNearbyItem';

import * as styles from './styles.css';

interface IPlacesNearbyProps {
  placesNearby: IPlaceNearby[];
}

export function PlacesNearby({ placesNearby }: IPlacesNearbyProps) {
  return (
    <Layout>
      <div className={styles['container']}>
        <div className={styles['header']}>
          <Header1 as="h2" fontWeight="bold">
            Места поблизости
          </Header1>
        </div>
        <VerticalSlider arrow={Arrow} containerClass={styles['slider']}>
          {placesNearby.map(item => (
            <PlacesNearbyItem key={item.title} {...item} />
          ))}
        </VerticalSlider>
      </div>
    </Layout>
  );
}
